import axios from "axios";

const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
    withXSRFToken: true,
})

// TODO: Add error handling that converts Axios errors into typed errors, extending something like a base "ApiError" type
// e.g. 422 -> ValidationError, 500 -> ServerError, 404 -> NotFoundError, 401 -> NotAuthenticatedError, 403 -> NotAuthorisedError, etc.

export default client